import { BACKEND_CONSTANTS } from './constants'
import { get } from './helpers'

const sync = async type => get(`sync/shopify/${type}`, BACKEND_CONSTANTS.SYNC.SHOPIFY)

export { sync }
